@if (config().visible) {
  @if (config().isHeading) {
    <h3 [id]="config().attrName">{{ text() }}</h3>
  } @else {
    <p [id]="config().attrName" [ngStyle]="config().style">{{ text() }}</p>
  }
}
